// extracted by mini-css-extract-plugin
module.exports = {"tableStyle":"previewBulkCandidateTable_tableStyle__1VouH"};